import React from 'react';

import { HoldingsReport } from '@ndvr/reporting-api';

import { formatCurrency } from 'utils';

import { getHoldingsSummary, HOLDINGS_SUMMARY_TOOLTIPS } from '../../holdings';
import { formatFullCurrency, formatSignedCompactCurrency } from '../../reporting/format';
import { HeroStatCard } from '../../reporting/HeroStatCard';

interface HoldingsHeroProps {
    report?: HoldingsReport | null;
    isLoading?: boolean;
}

export const HoldingsHero = ({ report, isLoading }: HoldingsHeroProps) => {
    const { marketValue, unrealized, costBasis, positions } = report
        ? getHoldingsSummary(report)
        : { marketValue: 0, unrealized: 0, costBasis: 0, positions: 0 };

    const stats = [
        {
            label: 'Total Market Value',
            value: formatCurrency(marketValue),
            tooltip: formatFullCurrency(marketValue),
            calculation: HOLDINGS_SUMMARY_TOOLTIPS.marketValue,
        },
        {
            label: 'Unrealized Gain / Loss',
            value: formatSignedCompactCurrency(unrealized),
            tooltip: formatFullCurrency(unrealized),
            calculation: HOLDINGS_SUMMARY_TOOLTIPS.unrealized,
            signedValue: unrealized,
            showArrow: true,
        },
        {
            label: 'Cost Basis',
            value: formatCurrency(costBasis),
            tooltip: formatFullCurrency(costBasis),
            calculation: HOLDINGS_SUMMARY_TOOLTIPS.costBasis,
        },
        {
            label: 'Positions',
            value: positions.toLocaleString('en-US'),
            tooltip: `${positions.toLocaleString('en-US')} positions`,
        },
    ];

    return <HeroStatCard stats={stats} isLoading={isLoading} />;
};
